import apiService from './api';

const READING_URL = '/reading';

// Mark a chapter as read
export const markChapterAsRead = async (readingData) => {
  try {
    const response = await apiService.post(READING_URL, readingData);
    return response;
  } catch (error) {
    console.error('Failed to mark chapter as read:', error);
    throw error;
  }
};

// Remove a chapter from a reader's reading history
export const removeChapterRead = async (readingId) => {
  try {
    const response = await apiService.delete(`${READING_URL}/${readingId}`);
    return response;
  } catch (error) {
    console.error('Failed to remove chapter read:', error);
    throw error;
  }
};

// Update a reading entry
export const updateReadingEntry = async (readingId, updateData) => {
  try {
    const response = await apiService.put(`${READING_URL}/${readingId}`, updateData);
    return response;
  } catch (error) {
    console.error('Failed to update reading entry:', error);
    throw error;
  }
}; 